import { FormatQuoteRounded, NumbersRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { memo, SyntheticEvent } from 'react';

interface CreateNewLabelButtonProps {
  onCreateLabel: (event: SyntheticEvent) => void;
  selectionMode: string;
}

export const CreateNewLabelButton = memo(function CreateNewLabelButton({
  onCreateLabel,
  selectionMode,
}: CreateNewLabelButtonProps) {
  return (
    <Button
      variant="text"
      fullWidth
      size="medium"
      sx={{
        textAlign: 'start',
        justifyContent: 'flex-start',
      }}
      onClick={onCreateLabel}
      startIcon={
        selectionMode === 'reasons' ? (
          <FormatQuoteRounded />
        ) : (
          <NumbersRounded />
        )
      }
    >
      {selectionMode === 'reasons'
        ? 'Create New Reason'
        : 'Create New Tracked Keyword'}
    </Button>
  );
});
